import { Collapsible } from "../collapsible";

export default class Faqs {
  constructor($elem) {
    new Collapsible($elem.find(".accordion"));
  }
}
